// src/services/facilityService.js
import axiosInstance from './axiosConfig'; // Your configured axios instance

/**
 * Fetches the information for the single facility from the backend.
 * Assumes the backend endpoint is GET /api/facility/info
 * @returns {Promise<object>} A promise that resolves to the facility data object.
 * @throws {Error} If the API call fails.
 */
export const getFacilityInfo = async () => {
    try {
        const response = await axiosInstance.get('/facility/info');
        return response.data; // The backend should return the facility object directly
    } catch (error) {
        // Log the error for debugging
        console.error("API Error fetching facility info (/facility/info):", error.response?.data || error.message);
        // Re-throw the error so the component knows the call failed
        throw error;
    }
};

export const updateFacilityInfo = async (data) => {
    try {
        const response = await axiosInstance.put('/facility/info', data);
        return response.data;
    } catch (error) {
        console.error("API Error updating facility info:", error.response?.data || error.message);
        throw error;
    }
};

export const addClosure = async (data) => {
    try {
        const response = await axiosInstance.post('/facility/closures', data);
        return response.data;
    } catch (error) {
        console.error("API Error adding closure:", error.response?.data || error.message);
        throw error;
    }
};

export const getClosures = async (params) => { // { start, end, facilityId }
    try {
        const response = await axiosInstance.get('/facility/closures', { params });
        return response.data;
    } catch (error) {
        console.error("API Error fetching closures:", error.response?.data || error.message);
        throw error;
    }
};

export const deleteClosure = async (id, deleteSeries = false) => {
    try {
        const response = await axiosInstance.delete(`/facility/closures/${id}`, { data: { deleteSeries } });
        return response.data;
    } catch (error) {
        console.error("API Error deleting closure:", error.response?.data || error.message);
        throw error;
    }
};